import { axiosInstance } from "../../_base/axios.instance";

export async function getAllStates() {
  const response = await axiosInstance.get(
    "https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome",
    {
      withCredentials: false
    }
  );
  return response;
};
